import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IBomLineCS {
    csBomID: number;
    csItemID: number;
    csOperationTypeID: number;
    dataAreaID: string;
    lineCreationSequenceNumber: number;
    bomId: string;
    itemNumber: string;
    consumptionWarehouseId: string;
    consumptionSiteId: string;
    productUnitSymbol: string;
    lineType: string;
    flushingPrinciple: string;
    vendorAccountNumber: string;
    routeOperationNumber: number;
    quantity: number;
    stdSailItem: boolean;
}

export const getBomLinesByRouteCS = async (
    csRouteID: number,
): Promise<IBomLineCS[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IBomLineCS[]>(
        `/RouteOperation/GetBomLinesByRouteCS/${csRouteID}`,
    );
    return response.data;
};
